import { render, staticRenderFns } from "./HelpCenterManagement.vue?vue&type=template&id=76296178&scoped=true&"
import script from "./HelpCenterManagement.vue?vue&type=script&lang=js&"
export * from "./HelpCenterManagement.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterManagement.vue?vue&type=style&index=0&id=76296178&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76296178",
  null
  
)

export default component.exports